import script from "./NotificationActionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationActionModal.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationActionModal.css?vue&type=style&index=0&id=32c2ab06&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c2ab06"]])

export default __exports__